import { render, staticRenderFns } from "./Factoring.vue?vue&type=template&id=232fc6de&"
import script from "./Factoring.vue?vue&type=script&lang=ts&"
export * from "./Factoring.vue?vue&type=script&lang=ts&"
import style0 from "./Factoring.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports